import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../../utils';

interface SettingsPageHeaderProps {
  /** Title of the settings page */
  title: string;
  /** Icon to display next to the title (should match sidebar icon) */
  icon: IconDefinition;
  /** Description text displayed below the title */
  description: string;
  /** Optional subtitle displayed below the description */
  subtitle?: string;
  className?: string;
}

/**
 * Reusable header component for settings pages.
 * Displays a title with icon, description, and optional subtitle.
 */
export function SettingsPageHeader({
  title,
  icon,
  description,
  subtitle,
  className,
}: SettingsPageHeaderProps) {
  return (
    <div className={cn('tw-mb-6', className)} style={{ padding: '24px' }}>
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
        <FontAwesomeIcon
          icon={icon}
          className="tw-text-gray-900"
          style={{ fontSize: '20px' }}
        />
        <h1
          className="tw-text-gray-900 tw-m-0"
          style={{ fontSize: '24px', fontWeight: 600 }}
        >
          {title}
        </h1>
      </div>
      <p
        className="tw-text-gray-600 tw-m-0 tw-mb-1"
        style={{ fontSize: '14px' }}
      >
        {description}
      </p>
      {subtitle && (
        <p
          className="tw-text-gray-500 tw-m-0 tw-mt-1"
          style={{ fontSize: '14px' }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
